import { forwardRef, InputHTMLAttributes } from "react";
import { useFormFieldState } from "../FormComponentHooks";
import styles from "./FormField.module.less";
import { extractValueProps, FormFieldProps } from "./FormFieldProps";

export type InputNumberProps =
  & InputHTMLAttributes<HTMLInputElement>
  & FormFieldProps<number>;

export const InputNumber = forwardRef<HTMLInputElement, InputNumberProps>(
  function InputNumber(props, ref) {
    const [valueProps, { ...inputProps }] = extractValueProps(props);
    const [value, setValue] = useFormFieldState(valueProps, 0);

    return (
      <input
        ref={ref}
        type="number"
        className={styles.input}
        {...inputProps}
        value={value}
        onChange={(e) => setValue(e.target.valueAsNumber)}
      />
    );
  },
);
